

define(['angular', 'squid/index', 'components/xo-device-info/dist/index', 'components/xo-beaver/dist/logger'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-fn', ['squid', 'xo-device-info', 'beaver']).factory('$fn', function ($rootScope, $window, $DeviceInfo, $logger, $config, $util, $meta, $pxp, $locale, $q) {
        var fncls = 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99';
        var token;

        if ($meta.baToken) {
            $logger.info('BEAM_In_Hermes_Checkout');
            token = $meta.baToken;
        } else {
            token = $rootScope.token || $meta.token;
        }

        var options = {
            fnSessionId: token,
            sourceId: 'HERMES_SIGNIN',
            allowsCustomEvent: typeof CustomEvent === 'function'
        };

        function init() {
            if (!options.allowsCustomEvent) {
                // remove IE traffic which does not support CustomEvent()
                $logger.info('FN_custom_event_undefined');
                options.fnUrl = $config.urls.fraudnetUrl.active;
                options.passive = false;
                $logger.info('FN_Initialised');
                return $q.when();
            }

            var country = $locale.country;
            return $pxp('xo_hermesnode_config', { 'ctx.COUNTRY': country }, 'xo_hermesnode_fraudnet_switch_treatment').then(function (result) {
                var treatmentName = result && result.treatment_name || '';
                if (treatmentName) {
                    $logger.info('FN_passive_treatment');
                    options.fnUrl = $config.urls.fraudnetUrl.passive;
                    options.passive = true;
                } else {
                    $logger.info('FN_active_treatment');
                    options.fnUrl = $config.urls.fraudnetUrl.active;
                    options.passive = false;
                }
                $logger.info('FN_Initialised');
            });
        }

        var enableFraudnet = function enableFraudnet() {
            var userAgent = $window.navigator.userAgent;

            // Disable for web view
            if ($DeviceInfo.isApp()) {
                if ($window.enableFraudNetForMobileWebView) {
                    $logger.info('Enable_FN_MobileApp_PXP_Decision');
                    return true;
                }

                $logger.info('Disable_FN_Mobileapp');
                return false;
            } else if (userAgent.indexOf('EtsyInc') > -1) {
                $logger.info('Disable_FN_Etsy');
                return false;
            }
            $logger.info('Enable_FN');
            return true;
        };

        function injectScript(fnUrl) {
            var script = document.createElement('script');
            script.id = 'js-sync';
            script.src = fnUrl;
            document.body.appendChild(script);
        }

        function injectIframe(beaconOptions) {
            var iframe = document.createElement('iframe');
            var dom;
            var doc;
            var where;

            iframe.src = 'javascript:false'; // eslint-disable-line no-script-url
            iframe.title = '';
            iframe.role = 'presentation';
            (iframe.frameElement || iframe).style.cssText = 'width: 0; height: 0; border: 0; display: none;';

            where = document.getElementsByTagName('script');
            where = where[where.length - 1];
            where.parentNode.insertBefore(iframe, where);

            try {
                doc = iframe.contentWindow.document;
            } catch (e) {
                dom = document.domain;
                iframe.src = 'javascript:var d=document.open();d.domain="' + dom + '";void(0);'; // eslint-disable-line no-script-url
                doc = iframe.contentWindow.document;
            }

            doc.open()._l = function () {
                var js = this.createElement('script');
                if (dom) {
                    this.domain = dom;
                }
                js.id = 'js-iframe-async';
                js.src = beaconOptions.fnUrl;
                this.body.appendChild(js);
            };

            doc.write('<body onload="document._l();">');
            doc.close();
        }

        function _injectConfig(configOptions) {
            var script = document.getElementById('fconfig');

            if (script) {
                if (script.parentNode) {
                    script.parentNode.removeChild(script);
                }
            }

            script = document.createElement('script');
            script.id = 'fconfig';
            script.type = 'application/json';
            script.setAttribute('fncls', fncls);

            script.text = '{"f": "' + configOptions.fnSessionId + '", "s": "' + configOptions.sourceId + '", "cb": "fnCallback"}';
            document.body.appendChild(script);
        }

        /**
         * Loads the fraudnet beacons (triggers 2 image beacons to c.paypal.com and c6.paypal.com)
         *
         * Integration pattern ripped from the Fraudnet Integration guide:
         * https://confluence.paypal.com/display/RiskDataAcquisition/FraudNet+Client+System+Integration+Guide+3.0#FraudNetClientSystemIntegrationGuide3.0-IntegrationCode
         */
        function _loadBeacon(beaconOptions) {
            if ($DeviceInfo.isApp() && $window.enableFraudNetForMobileWebView) {
                injectScript(beaconOptions.fnUrl);
            } else {
                injectIframe(beaconOptions);
            }
        }

        function trigger(scope) {
            var fnLoaded = !!$rootScope.fnLoaded;

            if (fnLoaded) {
                return false;
            }

            if (options.fnUrl) {
                if (enableFraudnet()) {
                    $window.fnCallback = function () {
                        if (scope) {
                            scope.$emit('fnCallback');
                        }
                    };
                    _injectConfig(options);
                    _loadBeacon(options);
                    $rootScope.fnLoaded = true;
                    return true;
                }
            }
            return false;
        }

        /**
         * send a payload to fraudnet for analysing typing speed
         * @param type
         */
        function sendTypingSpeedPayload(type) {

            var tsLoadPayload = {
                'detail': {
                    'type': type
                }
            };

            if (type === 'Hermes') {
                tsLoadPayload.detail['fields'] = ['username', 'password'];
            }
            if (type === 'HermesUL') {
                tsLoadPayload.detail['frame'] = 'injectedUl';
                tsLoadPayload.detail['fields'] = ['email', 'password'];
            }

            if (type && options.passive) {
                var event = new CustomEvent('tsLoad', tsLoadPayload);
                window.document.dispatchEvent(event);
                $logger.info('Dispatched_FN_TS_Payload_' + type);
            }
        }

        return {
            init: init,
            trigger: trigger,
            sendTypingSpeedPayload: sendTypingSpeedPayload
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-login-components/src/login/fn.js
 ** module id = 163
 ** module chunks = 1
 **/